var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 18" }, props),
    React.createElement("path", { d: "M15.667.667H2.333c-.916 0-1.658.75-1.658 1.666l-.008 15L4 14h11.667c.916 0 1.666-.75 1.666-1.667v-10c0-.917-.75-1.666-1.666-1.666zm0 11.666H3.308l-.491.492-.484.483V2.333h13.334v10zM8.167 9h1.666v1.666H8.167V9zm0-5h1.666v3.333H8.167V4z" })
  );
});